import { render, staticRenderFns } from "./NavbarDestinations.vue?vue&type=template&id=ff336454&scoped=true&"
import script from "./NavbarDestinations.vue?vue&type=script&lang=js&"
export * from "./NavbarDestinations.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDestinations.vue?vue&type=style&index=0&id=ff336454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff336454",
  null
  
)

export default component.exports